module.exports = __webpack_public_path__ + "static/fremantlemedia-77fd4ba99d30836c4970cec3cd35ff38.jpg";